import React, { useState, useEffect } from "react";
import SideBar from "../components/SideBar";
import TopBar from "../components/TopBar";

function AllVolunteer() {
  const [showModal, setShowModal] = useState(false);
  const [selectedOpportunity, setSelectedOpportunity] = useState(null);
  const [opportunities, setOpportunities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const TEST_BASE_URL = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    if (storedUser) {
      const name =
        storedUser.name ||
        `${storedUser.first_name || ""} ${storedUser.last_name || ""}`.trim() ||
        storedUser.username ||
        storedUser.email?.split("@")[0] ||
        "User";

      setUserName(name);
      setUserEmail(storedUser.email || "");
    }
  }, []);

  useEffect(() => {
    const fetchOpportunities = async () => {
      setLoading(true);
      setError("");

      try {
        const response = await fetch(
          `${TEST_BASE_URL}/volunteer-opportunities`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
          }
        );

        console.log("Response status:", response.status);

        if (!response.ok) {
          const text = await response.text();
          throw new Error(`Failed to fetch: ${response.status} - ${text}`);
        }

        const result = await response.json();
        const list = result?.data?.data || [];

        setOpportunities(list);
      } catch (err) {
        console.error("Error fetching opportunities:", err);
        setError("Failed to load volunteer opportunities.");
      } finally {
        setLoading(false);
      }
    };

    fetchOpportunities();
  }, []);

  const openModal = (opportunity) => {
    setSelectedOpportunity(opportunity);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedOpportunity(null);
  };

  return (
    <section className="dashboard">
      <SideBar isOpen={sidebarOpen} />
      <div className="body-content">
        <TopBar onToggleSidebar={toggleSidebar} />

        <div className="bottom-content">
          <div className="prayer-title">
            <span>Volunteering</span>
          </div>

          <div className="volunteer-head">
            <span className="fs-5">Current Volunteer Opportunities</span>
          </div>

          {loading && <p className="mt-4">Loading opportunities...</p>}
          {error && <p className="text-danger mt-4">{error}</p>}

          {!loading && !error && (
            <div className="row mt-4">
              {opportunities.length > 0 ? (
                opportunities.map((op) => (
                  <div className="col-md-4 mb-4" key={op.id}>
                    <div className="volunteer-card">
                      <h6>{op.title || "Untitled Opportunity"}</h6>
                      <span>
                        <b>Roles Needed:</b> {op.roles_needed || "N/A"}
                      </span>
                      <span>
                        <b>Special Requirements:</b>{" "}
                        {op.special_requirements || "None"}
                      </span>
                      <div>{op.hours_required || "N/A"}+ hours</div>
                      <div className="volunteer-button">
                        <button onClick={() => openModal(op)}>Sign Up</button>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p>No volunteer opportunities available at the moment.</p>
              )}
            </div>
          )}
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="rsvp-backdrop">
          <div className="rsvp-box">
            <h4 className="pb-1">Sign Up/Volunteer</h4>
            <h6>{selectedOpportunity?.title || "Volunteer Signup"}</h6>

            <form>
              <label>Confirm name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter your name"
                value={userName}
                readOnly
              />

              <label>Email</label>
              <input
                type="email"
                className="form-control"
                placeholder="Enter email"
                value={userEmail}
              />

              <label>Select volunteer roles</label>
              <select className="selectroles form-control">
                <option>Select Available Roles</option>
                <option>Chorister</option>
                <option>Media</option>
                <option>Protocol</option>
                <option>Welfare</option>
                <option>Logistics</option>
              </select>

              <label>Choose available hours</label>
              <select className="selectroles form-control">
                <option>Choose Hours</option>
                <option>Morning</option>
                <option>Afternoon</option>
                <option>Evening</option>
              </select>

              <label>Do you have any relevant skills or experience?</label>
              <textarea
                rows="5"
                placeholder="Enter relevant skills"
                className="form-control"
              ></textarea>

              <div className="confirm">
                <input type="checkbox" id="agreement1" />
                <label htmlFor="agreement1">
                  I confirm my availability and willingness to serve for this
                  opportunity.
                </label>
              </div>

              <div className="confirm">
                <input type="checkbox" id="agreement2" />
                <label htmlFor="agreement2">
                  I agree to attend any necessary briefings or training related
                  to this role.
                </label>
              </div>

              <div className="modalbutton">
                <button type="button" onClick={closeModal}>
                  Cancel
                </button>
                <button type="submit">
                  <a href="/managesignup">Signup</a>
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </section>
  );
}

export default AllVolunteer;
